import React, { useState, useEffect, useRef } from 'react'
import parse from 'html-react-parser'
import { useNavigate, useParams, Link } from "react-router-dom"
import Swal from 'sweetalert2'
import Nav from './Nav'
import axiosJWT from '../JwtToken'

const Detail = () => {
    const { kluster, code } = useParams() // Pakai id dari URL
    const [list, setList] = useState([])
    const [detail, setDetail] = useState(null)
    const [loading, setLoading] = useState(true)

    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    const navigate = useNavigate()

    // Helper format teks buat Breadcrumb
    const formatTxt = (str) => str ? str.replaceAll('-', ' ').replaceAll('_', '/') : ""

    useEffect(() => {
        // Reset fetch status kalau ID berubah (misal klik dari sidebar)
        const initLoad = async () => {
            setLoading(true)
            await Promise.all([getData(code), getList(kluster)])
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            setLoading(false)
        }
        initLoad()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, kluster])

    const getData = async (id_csr) => {
        try {
            // Endpoint sesuaikan dengan API detail katalog lu
            const response = await axiosJWT.get(`/api/csr/portal/${id_csr}`)
            setDetail(response.data)
        } catch (err) { console.error("Gagal load detail:", err) }
    }

    const getList = async (slugKategori) => {
        try {
            const formattedKategori = formatTxt(slugKategori)
            // Ambil 5 data lainnya di klaster yang sama buat sidebar kiri
            const response = await axiosJWT.post("/api/csr/portal/filter-cluster", {
                cluster: formattedKategori,
                jml: 5
            })
            setList(response.data)
        } catch (err) { console.error("Gagal load list sidebar:", err) }
    }

    // const downloadFileCsr = (fullUrl) => {
    //     try {
    //         if (!fullUrl) return alert("File tidak tersedia")

    //         // 1. Ambil nama folder dan file dari URL lengkap
    //         const urlParts = fullUrl.split('/')
    //         const folder = urlParts[urlParts.length - 2]
    //         const fileName = urlParts[urlParts.length - 1]

    //         // 2. Langsung arahkan lokasi browser ke endpoint backend
    //         // Browser akan langsung otomatis download tanpa ngebuka tab baru kosong
    //         window.location.href = `/api/csr/portal/download/${folder}/${fileName}`

    //     } catch (err) {
    //         console.error("Download Error:", err)
    //         alert("Gagal mendownload file TJSL/CSR.")
    //     }
    // }

    const openFile = (url) => {
        setFileUrl(url)
        setShowModalFile(true)
    }

    // const handleAmbilProgram = async () => {
    //     // 1. Munculin modal input biar sekali jalan (Anti-bolak-balik)
    //     const { value: formValues } = await Swal.fire({
    //         title: 'Konfirmasi Pengambilan',
    //         html:
    //             '<div class="text-left">' +
    //             '<label style="font-weight: 600">Jadwal Pertemuan:</label>' +
    //             '<input id="swal-input1" type="date" class="form-control mb-3">' +
    //             '<label style="font-weight: 600">Lokasi Pertemuan:</label>' +
    //             '<input id="swal-input2" type="text" class="form-control mb-3" placeholder="Contoh: Kantor Bappeda / Zoom">' +
    //             '<label style="font-weight: 600">Upload Surat Dukungan (PDF):</label>' +
    //             '<a id="btn-download-template" href="#" class="btn bg-transparent btn-link btn-block color-danger text-small text-left p-0" style="text-decoration: underline;">' +
    //             '<i class="zmdi zmdi-download mr-1"></i> Download Template Surat Dukungan' +
    //             '</a>' +
    //             '<input id="swal-input3" type="file" class="form-control" accept=".pdf">' +
    //             '</div>',
    //         focusConfirm: false,
    //         showCancelButton: true,
    //         confirmButtonText: 'Kirim Pengajuan',
    //         cancelButtonText: 'Batal',
    //         // --- INI KUNCINYA BIAR TOMBOLNYA SAMA ---
    //         customClass: {
    //             confirmButton: 'btn btn-raised btn-primary br-2',
    //             cancelButton: 'btn btn-raised btn-default br-2' // atau btn-danger kalo mau merah
    //         },
    //         buttonsStyling: false, // WAJIB set false biar class default Swal gak ganggu
    //         didOpen: () => {
    //             const btn = document.getElementById('btn-download-template')
    //             if (btn) {
    //                 btn.onclick = (e) => {
    //                     e.preventDefault()
    //                     downloadFileCsr('/files/template_csr/Template_Surat_Dukungan_TJSL.pdf')
    //                 }
    //             }
    //         },
    //         preConfirm: () => {
    //             const jadwal = document.getElementById('swal-input1').value
    //             const lokasi = document.getElementById('swal-input2').value
    //             const berkas = document.getElementById('swal-input3').files[0]
    //             if (!jadwal || !lokasi || !berkas) {
    //                 Swal.showValidationMessage('Jadwal, Lokasi dan Surat Dukungan wajib diisi!')
    //             }
    //             return { jadwal: jadwal, lokasi: lokasi, berkas: berkas }
    //         }
    //     })

    //     if (formValues) {
    //         try {
    //             // 2. Bungkus pake FormData karena ada file
    //             const formData = new FormData()
    //             formData.append('katalogId', detail._id)
    //             formData.append('jadwal_meeting', formValues.jadwal)
    //             formData.append('lokasi_meeting', formValues.lokasi)
    //             formData.append('file_surat', formValues.berkas) // Sesuaikan key di Multer backend

    //             // 3. Eksekusi
    //             await axiosJWT.post(`/api/csr/portal/realisasi/booking`, formData)

    //             Swal.fire('Berhasil!', 'Pengajuan terkirim. Silakan tunggu verifikasi.', 'success').then(() => {
    //                 navigate("/akun/kemitraan-tjsl")
    //             })

    //         } catch (err) {
    //             Swal.fire(
    //                 'Gagal',
    //                 (err.response && err.response.data && err.response.data.msg) || 'Terjadi kesalahan sistem.',
    //                 'error'
    //             )
    //         }
    //     }
    // }

    const handleAmbilProgram = async () => {
        // Cukup konfirmasi sederhana
        const result = await Swal.fire({
            title: 'Konfirmasi Pengambilan',
            text: "Anda yakin ingin mengambil program TJSL/CSR ini?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ya, Ambil Program',
            cancelButtonText: 'Batal',
            customClass: {
                confirmButton: 'btn btn-raised btn-primary br-2',
                cancelButton: 'btn btn-raised btn-default br-2'
            },
            buttonsStyling: false
        })

        if (result.isConfirmed) {
            try {
                await axiosJWT.post(`/api/csr/portal/realisasi/booking`, {
                    katalogId: detail._id
                })

                Swal.fire('Berhasil!', 'Pengajuan berhasil dikirim. Mohon menunggu informasi lebih lanjut dari pihak instansi terkait mengenai detail pertemuan.', 'success').then(() => {
                    navigate("/akun/kemitraan-tjsl")
                })
            } catch (err) {
                Swal.fire(
                    'Gagal',
                    (err.response && err.response.data && err.response.data.msg) || 'Terjadi kesalahan sistem.',
                    'error'
                )
            }
        }
    }

    if (loading) return <div className="text-center p-5"><i className="zmdi zmdi-hc-spin zmdi-spinner zmdi-hc-3x color-primary"></i></div>
    if (!detail) return <div className="text-center p-5">Data tidak ditemukan!</div>

    // Logic Tanggal Aman
    const tahunProgram = new Date(detail.tgl_pengajuan).getFullYear()
    const tglUpdate = new Date(detail.u_date || detail.i_date).toLocaleDateString('id-ID', {
        day: 'numeric', month: 'long', year: 'numeric'
    })

    return (<>
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item"><Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link></li>
                        <li className="breadcrumb-item active text-uppercase">KATALOG TJSL-CSR</li>
                        <li className="breadcrumb-item active">{formatTxt(kluster).toUpperCase()}</li>
                        <li className="breadcrumb-item active text-uppercase text-truncate" style={{ maxWidth: '200px' }}>{detail.nama_program}</li>
                    </ol>
                    <div className="btn-group w-300">
                        <button type="button" className="btn btn-warning btn-raised dropdown-toggle" data-toggle="dropdown">
                            KLASTER TJSL/CSR <i className="zmdi zmdi-chevron-down right only"></i>
                        </button>
                        <Nav />
                    </div>
                </nav>

                <div className="row mt-4">
                    {/* SIDEBAR KIRI: PROGRAM LAIN DI KLASTER INI */}
                    <div className="col-md-3">
                        <div className="card card-primary">
                            <div className="card-header"><h3 className='panel-title'>LAINNYA DI {detail.klaster.toUpperCase()}</h3></div>
                            <div className="card-body">
                                <div className="ms-media-list">
                                    {list.filter(i => i._id !== code).map((val, index) => (
                                        <Link to={`/csr-katalog/${kluster}/${val._id}`} key={index} className="media mb-2 text-decoration-none">
                                            <div className="media-left media-middle">
                                                <img className='d-flex mr-3 media-object' width="100%" src={val.gambar_design || '/assets/img/default-csr.jpg'} alt="thumb" />
                                            </div>
                                            <div className="media-body">
                                                <span className="media-heading color-dark font-bold text-small d-block text-truncate" style={{ maxWidth: '150px' }}>{val.nama_program}</span>
                                                <div className="media-footer text-small color-dark">
                                                    <i className="zmdi zmdi-pin color-danger mr-05"></i> {val.kelurahan_csr}, {val.kecamatan_csr}
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* MAIN CONTENT: DETAIL PROGRAM */}
                    <div className="col-md-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <div className="mb-2 d-flex align-items-center justify-content-between">
                                    <span className="label label-primary text-uppercase">{detail.klaster}</span>
                                    <small className="text-muted">
                                        <i className="zmdi zmdi-time mr-1"></i> Update: {tglUpdate}
                                    </small>
                                </div>
                                <h1 className='color-dark font-bold lh-125 mb-3'>{detail.nama_program}</h1>

                                <div className="thumbnail mb-3" style={{ border: 'none', background: '#f5f5f5', borderRadius: '10px', overflow: 'hidden' }}>
                                    <img width="100%" src={detail.gambar_design || '/assets/img/default-csr.jpg'} alt="Design TJSL/CSR" />
                                </div>

                                <div className="alert alert-success br-2 py-1 px-3 mb-2"><b>DESKRIPSI PROYEK</b></div>
                                <div className="color-dark lh-150 mb-4">
                                    {detail.deskripsi ? parse(detail.deskripsi) : 'Tidak ada deskripsi.'}
                                </div>

                                <div className="alert alert-info br-2 py-1 px-3 mb-2"><b>MANFAAT TJSL/CSR</b></div>
                                <div className="color-dark lh-150 mb-4">
                                    {detail.manfaat_csr ? parse(detail.manfaat_csr) : 'Belum dijelaskan.'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDEBAR: RINGKASAN DATA */}
                    <div className="col-md-3">
                        {/* TOMBOL AMBIL TJSL (Hanya muncul jika status Tersedia) */}
                        {detail.status === 'Tersedia' && (
                            <div className="card card-primary bg-primary mb-3 shadow-sm br-2 pb-2">
                                <div className="card-body text-center py-3">
                                    <h4 className="color-white font-bold mb-2">TJSL/CSR TERSEDIA</h4>
                                    <p className="color-white text-small mb-3">Tertarik berkontribusi? Klik tombol di bawah.</p>

                                    <button onClick={handleAmbilProgram} className="btn btn-raised btn-white btn-block color-primary font-bold br-2">
                                        <i className="zmdi zmdi-assignment-check mr-1"></i> AMBIL TJSL/CSR
                                    </button>

                                    {/* <a onClick={() => downloadFileCsr('/files/template_csr/Template_Surat_Dukungan_TJSL.pdf')} className="btn bg-transparent btn-link btn-block color-white text-small p-0 mt-2" style={{ textDecoration: 'underline' }}>
                                        <i className="zmdi zmdi-download mr-1"></i> Download Template Surat Dukungan
                                    </a> */}
                                </div>
                            </div>
                        )}

                        {detail.status === 'Selesai' && detail.nama_mitra ? (
                            <div className="card card-danger">
                                <div className="card-header bg-danger text-white">
                                    <h3 className='panel-title mb-0'><i className="fa fa fa-briefcase mr-2"></i> MITRA TJSL/CSR</h3>
                                </div>
                                <div className="card-body">
                                    <h4 className="m-0 color-danger">{detail.nama_mitra}</h4>
                                </div>
                            </div>
                        ) : null}

                        <div className="card card-success">
                            <div className="card-header bg-success text-white">
                                <h3 className='panel-title mb-0'><i className="zmdi zmdi-info-outline mr-2"></i> RINGKASAN INFO</h3>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-striped mb-0" style={{ fontSize: '0.9rem' }}>
                                        <tbody>
                                            <tr>
                                                <td className="font-bold text-left">Status</td>
                                                <td className='text-left'><span className={`badge ${detail.status === 'Selesai' ? 'badge-success' : 'badge-primary'}`}>{detail.status}</span></td>
                                            </tr>
                                            <tr>
                                                <td className="font-bold text-left">Nilai TJSL/CSR</td>
                                                <td className="color-primary font-bold text-left">
                                                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(detail.nilai_csr)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-bold text-left">Tahun</td>
                                                <td className='text-left'>{tahunProgram}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-bold text-left">Penerima</td>
                                                <td className='text-left'>{detail.nama_penerima}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-bold text-left">Kecamatan</td>
                                                <td className='text-left'>{detail.kecamatan_csr}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-bold text-left">Kelurahan</td>
                                                <td className='text-left'>{detail.kelurahan_csr}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="card card-warning mt-3">
                            <div className="card-header bg-warning text-white">
                                <h3 className='panel-title mb-0'><i className="zmdi zmdi-pin mr-2"></i> LOKASI</h3>
                            </div>
                            <div className="card-body">
                                <p className="mb-0 text-small">{detail.lokasi_csr}</p>
                            </div>
                        </div>

                        {detail.file_design && (
                            <button onClick={() => openFile(detail.file_design)} className="btn btn-raised btn-danger btn-block mt-3 br-2">
                                <i className="fa fa-file-pdf mr-1"></i> DESAIN / SPESIFIKASI
                            </button>
                        )}

                        {detail.rab_file && (
                            <button onClick={() => openFile(detail.rab_file)} className="btn btn-raised btn-danger btn-block br-2">
                                <i className="fa fa-file-pdf mr-1"></i> RAB / SURAT PERMOHONAN
                            </button>
                        )}

                        <Link to={-1} className="btn btn-raised btn-default btn-block br-2">
                            <i className="zmdi zmdi-arrow-left mr-1"></i> KEMBALI
                        </Link>
                    </div>
                </div>
            </div>
        </header>

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {/* MODAL PREVIEW SERTIFIKAT - Bungkus pake modal-open biar CSS template lu nangkep */}
        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-md">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalFile(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview File</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL/CSR"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}
    </>)
}

export default Detail